import React from 'react'
import { Button } from '@mui/material'

const OutlineButton = ({
  children,
  onClick,
  disabled = false,
  type = 'button',
  variant = 'outlined',
  startIcon = null,
  endIcon = null,
  size = 'medium',
  fullWidth = false,
  sx = {},
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      type={type}
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      size={size}
      fullWidth={fullWidth}
      sx={{
        borderColor: '#d1d5db',
        color: '#6b7280',
        backgroundColor: 'white',
        px: 3,
        py: 1.5,
        fontWeight: 500,
        borderRadius: '8px',
        textTransform: 'none',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
        '&:hover': {
          backgroundColor: '#f9fafb',
          borderColor: '#9ca3af',
          transform: 'translateY(-1px)',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
        '&:active': {
          transform: 'translateY(0)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
        },
        '&:disabled': {
          borderColor: '#e5e7eb',
          color: '#9ca3af',
          backgroundColor: '#f9fafb',
          transform: 'none',
          boxShadow: 'none',
        },
        transition: 'all 0.2s ease',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default OutlineButton
